export default "__VITE_ASSET__CiPngblN__"